/*
 * MARMOT: чистата логика на лендинга „Ранок" (бриф ранок-лендинг).
 * Liquid решава състоянието при рендер; това е само предпазът за кеширана
 * страница, отворена след края на последния ден: дали да смени блоковете.
 */
(function (root) {
  'use strict';

  // endMs е крайният момент от сървъра (полунощ след последния ден, Europe/Sofia).
  // Липсващ или счупен край → никога не сменя (по-консервативното: страницата
  // остава каквато я е нарисувал Liquid).
  function ranokEnded(endMs, nowMs) {
    var end = Number(endMs);
    if (!isFinite(end) || end <= 0) return false;
    return Number(nowMs) >= end;
  }

  var api = { ranokEnded: ranokEnded };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotRanokLogic = api;
})(typeof window !== 'undefined' ? window : this);
